import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import Accordion from 'components/Accordion';
// Utilities
import LandingPageForm from './LandingPageForm';

type Props = {
  defaultExpanded?: boolean;
  /** The Preview button relies on a `:quizId` route param (via QuizPagePreview's
   *  useParams), which isn't available when this section is embedded outside
   *  QuizFormPage's own route (e.g. QuizAgentDialog). Defaults to true so the
   *  main quiz form keeps its existing behaviour. */
  showPreview?: boolean;
}

const LandingPage:FC<Props> = ({ defaultExpanded, showPreview = true }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full" react-scroll="landingPage">
      <Accordion
        label={t('pages.quizForm.landingPageLabel')}
        icon="list"
        previewPage={showPreview ? 'start' : undefined}
        defaultExpanded={defaultExpanded}
      >
        <LandingPageForm />
      </Accordion>
    </div>
  )
}

export default LandingPage;
